import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogPostsComponent } from './blog-posts.component';
import { TranslateModule } from '@xref/ngx';

@NgModule({
  declarations: [BlogPostsComponent],
  exports: [BlogPostsComponent],
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class BlogPostsModule { }
